/* unplugin-vue-components disabled */import { render } from "./VoiceController.vue?vue&type=template&id=7d10b8f4"
import script from "./VoiceController.vue?vue&type=script&lang=js"
export * from "./VoiceController.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__